import { default as axios, AxiosRequestConfig, AxiosResponse } from 'axios';
import { ClientBase } from '../HttpClientSelector';

class Axios implements ClientBase {
  private static _instance: Axios;

  private constructor() {
    axios.interceptors.request.use(
      function (config) {
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response: AxiosResponse<any>) {
        const _responseData = response.data || null;
        if (_responseData == null) {
          return Promise.reject();
        } else if (_responseData.Error == true) {
          return Promise.reject();
        }
        return _responseData;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  private AxiosOptions: AxiosRequestConfig = { withCredentials: true };

  public static Instance(): Axios {
    return this._instance || (this._instance = new this());
  }

  public Post = <TOut>(options: {
    data: any;
    contentType: string;
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<TOut> => {
    const _url = (options.baseUrl || '') + (options.serviceUrl || '') + (options.methodUrl || '');
    return axios.post(_url, options.data, this.AxiosOptions);
  };

  public Get = <TOut>(options: {
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<TOut> => {
    const _url = (options.baseUrl || '') + (options.serviceUrl || '') + (options.methodUrl || '');
    return axios.get(_url, this.AxiosOptions);
  };
}

const AxiosInstance = Axios.Instance();

export default AxiosInstance;
